import type { TemplateMeta } from '../../types';
import { Box2RowIcon } from './Icon';

export const yearly6BoxMonthCardMeta: TemplateMeta = {
  name: '6 Box Grid',
  orientation: 'portrait',
  Icon: Box2RowIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Date range',
  eventListDisplayFullLabel: 'Full year',
  eventListRangePicker: 'month-range',
};
